import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Lists",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.96 14.25a4.55 4.55 0 0 0 1.32-3.05 3.103 3.103 0 0 0-3.11-3.09 3.12 3.12 0 0 0-3.03 2.4v.02c1.58.91 2.63 2.59 2.64 4.52v8.8h3.5c.95 0 1.72-.77 1.72-1.72v-4.44a3.44 3.44 0 0 0-3.03-3.42h-.02ZM3.75 23.86h3.51v-8.8c.02-1.93 1.07-3.6 2.62-4.5h.03c-.33-1.41-1.56-2.44-3.04-2.44a3.11 3.11 0 0 0-3.11 3.09c.04 1.19.54 2.26 1.31 3.05-1.73.2-3.07 1.66-3.07 3.43v4.45c0 .95.77 1.72 1.72 1.72zm5.26-8.74v10.49c0 .95.77 1.72 1.72 1.72h10.53c.95 0 1.72-.77 1.72-1.72V15.12c0-1.93-1.57-3.5-3.5-3.5h-1.52c.27-.25.5-.54.7-.84v-.02c.17-.25.33-.53.45-.83v-.04c.24-.51.37-1.1.38-1.72 0-1.94-1.57-3.51-3.5-3.51s-3.5 1.57-3.5 3.5c.01.63.15 1.22.38 1.75v-.03c.13.33.28.62.46.88v-.02c.2.33.44.61.7.86s-1.54 0-1.54 0c-1.93 0-3.5 1.57-3.5 3.5Z"
    })
  }));
};